'use client'
import { Ninja } from '../platforms'

export const AccountLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="flex h-screen w-screen justify-center bg-[#FAFAFC] pt-9 sm:pt-[132px]">
    <section className="flex w-full max-w-[480px] flex-col items-center p-2">
      <div className="flex w-full justify-center px-2">
        <Ninja width={55} height={55} className="rounded-md bg-white" />
      </div>
      <div className="flex w-full">{children}</div>
    </section>
  </div>
)
